module.exports = __webpack_public_path__ + "static/media/03_DSC0258.73c4cb79.jpg";